// 지도 상호작용 전용 Store
// SelectInteraction, ModifyInteraction 등 상호작용 관리

const state = {
  // 선택된 요소들
  selectedFeatures: [],
  selectedFeatureIds: [],

  // 상호작용 모드
  isSelectMode: true,
  isModifyMode: false,

  // 이벤트 상태
  isModifying: false,
  lastModifiedFeatureId: null
};

const getters = {
  getSelectedFeatures: state => state.selectedFeatures,
  getSelectedFeatureIds: state => state.selectedFeatureIds,
  getIsSelectMode: state => state.isSelectMode,
  getIsModifyMode: state => state.isModifyMode,
  getIsModifying: state => state.isModifying,
  getLastModifiedFeatureId: state => state.lastModifiedFeatureId
};

const mutations = {
  SET_SELECTED_FEATURES(state, features) {
    state.selectedFeatures = features;
    state.selectedFeatureIds = features.map(feature => feature.getId()).filter(id => id);
  },

  SET_IS_SELECT_MODE(state, isSelectMode) {
    state.isSelectMode = isSelectMode;
  },

  SET_IS_MODIFY_MODE(state, isModifyMode) {
    state.isModifyMode = isModifyMode;
  },

  SET_IS_MODIFYING(state, isModifying) {
    state.isModifying = isModifying;
  },

  SET_LAST_MODIFIED_FEATURE_ID(state, featureId) {
    state.lastModifiedFeatureId = featureId;
  }
};

const actions = {
  // 상호작용 초기화
  initializeInteractions({ commit }) {
    console.log('[MapInteractionsStore] 상호작용 초기화');
    // OpenLayers 객체는 컴포넌트에서 관리
  },

  // 선택 모드 토글
  toggleSelectMode({ commit, state }) {
    const newMode = !state.isSelectMode;
    commit('SET_IS_SELECT_MODE', newMode);
    console.log('[MapInteractionsStore] 선택 모드:', newMode);
  },

  // 수정 모드 토글
  toggleModifyMode({ commit, state }) {
    const newMode = !state.isModifyMode;
    commit('SET_IS_MODIFY_MODE', newMode);
    console.log('[MapInteractionsStore] 수정 모드:', newMode);
  },

  // 선택된 요소들 업데이트
  updateSelectedFeatures({ commit }, features) {
    console.log('[MapInteractionsStore] 선택된 요소들 업데이트:', features);
    commit('SET_SELECTED_FEATURES', features);
  },

  // 선택 해제
  clearSelection({ commit }) {
    console.log('[MapInteractionsStore] 선택 해제');
    commit('SET_SELECTED_FEATURES', []);
  },

  // 상호작용 정리
  destroyInteractions({ commit }) {
    console.log('[MapInteractionsStore] 상호작용 정리');

    commit('SET_SELECTED_FEATURES', []);
    commit('SET_IS_SELECT_MODE', true);
    commit('SET_IS_MODIFY_MODE', false);
    commit('SET_IS_MODIFYING', false);
    commit('SET_LAST_MODIFIED_FEATURE_ID', null);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
